<template>
	<div class="content-border">
		<div class="content-border-title" v-if="title" >
			{{title}}
		</div>
		<div class="content-border-top"></div>
		<div class="content-border-bottom"></div>
		<div class="content-border-1"></div>
		<div class="content-border-2"></div>
		<div class="content-border-3"></div>
		<div class="content-border-4"></div>
		<slot />
	</div>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: ""
			}
		}
	}
</script>

<style lang="less" scoped>
	.content-border {
		background: #FFFFFF;
		box-shadow: inset 0px 8px 24px 0px rgba(27, 126, 242, 0.16);
		position: relative;

		.content-border-title {
			width: 368px;
			height: 36px;
			text-align: center;
			line-height: 34px;
			font-size: 16px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 500;
			color: #FFFFFF;
			background: url('../../../../assets/report/border-bg.png') no-repeat;
			background-size: 100% 100%;
			position: absolute;
			left: 50%;
			top: 0%;
			transform: translate(-50%, 0%);
		}

		.content-border-1 {
			width: 12px;
			height: 12px;
			position: absolute;
			top: 0px;
			left: 0px;
			background: url('../../../../assets/report/border-1.png') no-repeat;
			background-size: 100% 100%;
		}

		.content-border-2 {
			width: 12px;
			height: 12px;
			position: absolute;
			top: 0px;
			right: 0px;
			background: url('../../../../assets/report/border-2.png') no-repeat;
			background-size: 100% 100%;
		}

		.content-border-3 {
			width: 12px;
			height: 12px;
			position: absolute;
			bottom: 0px;
			left: 0px;
			background: url('../../../../assets/report/border-3.png') no-repeat;
			background-size: 100% 100%;
		}

		.content-border-4 {
			width: 12px;
			height: 12px;
			position: absolute;
			bottom: 0px;
			right: 0px;
			background: url('../../../../assets/report/border-4.png') no-repeat;
			background-size: 100% 100%;
		}

		.content-border-top {
			width: 100%;
			height: 1px;
			position: absolute;
			top: 0px;
			left: 0px;
			background: linear-gradient(270deg, #FFFFFF 0%, #1B7EF2 49%, #FFFFFF 100%);
			background-size: 100% 100%;
		}

		.content-border-bottom {
			width: 100%;
			height: 1px;
			position: absolute;
			bottom: 0px;
			left: 0px;
			background: linear-gradient(270deg, #FFFFFF 0%, #1B7EF2 49%, #FFFFFF 100%);
			background-size: 100% 100%;
		}
	}
</style>